const EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export function IsValidEmail(email) {
    return EmailRegex.test(email.toLowerCase());
}


// WEBPACK FOOTER //
// ./Statics/scripts/Core/Validators/EmailValidator.js